// 객체
const nurse = [
    { name: '진주연', drNameGlb: '진주연', belong: '혈액암병원 파트장', belongGlb: '혈액암병원 파트장', detailField: '', imageSrc: 'doctor-blood10.png' },
    { name: '김나현', drNameGlb: '김나현', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'nurse_blood01.png' },
    { name: '김민주', drNameGlb: '김민주', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood06.png' },
    { name: '소은경', drNameGlb: '소은경', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'nurse_blood09.png' },
    { name: '김유림', drNameGlb: '김유림', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'nurse_blood02.png' },
    { name: '김주연', drNameGlb: '김주연', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'nurse_blood03.png' },
    { name: '김태연', drNameGlb: '김태연', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood-new01.png' },
    { name: '노인경', drNameGlb: '노인경', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood08.png' },
    { name: '박소민', drNameGlb: '박소민', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'nurse_blood04.png' },
    { name: '박은세', drNameGlb: '박은세', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'nurse_blood05.png' },
    { name: '변윤지', drNameGlb: '변윤지', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood02.png' },
    { name: '손다희', drNameGlb: '손다희', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood03.png' },
    { name: '안소연', drNameGlb: '안소연', belong: '카티코디네이터', belongGlb: '카티코디네이터', detailField: '', imageSrc: 'doctor-blood-new03.png' },
    // { name: '이윤지', drNameGlb: '이윤지', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood07.png' },
    { name: '이지아', drNameGlb: '이지아', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood04.png' },
    { name: '전희원', drNameGlb: '전희원', belong: '혈액암가족돌봄센터코디네이터', belongGlb: '혈액암가족돌봄센터코디네이터', detailField: '', imageSrc: 'doctor-blood-new02.png' },
    { name: '정지혜', drNameGlb: '정지혜', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'doctor-blood01.png' },
    { name: '정향주', drNameGlb: '정향주', belong: '조혈모세포이식코디네이터', belongGlb: '조혈모세포이식코디네이터', detailField: '', imageSrc: 'doctor-blood09.png' },
    { name: '황은지', drNameGlb: '황은지', belong: '전담간호사', belongGlb: '전담간호사', detailField: '', imageSrc: 'nurse_blood10.png' },
    // { name: '김보라', drNameGlb: '김보라', belong: '혈액암병원 외래간호사', belongGlb: '혈액암병원 외래간호사', detailField: '', imageSrc: 'doctor-blood22.png' },
    { name: '김자은', drNameGlb: '김자은', belong: '혈액암병원 외래간호사', belongGlb: '혈액암병원 외래간호사', detailField: '', imageSrc: 'doctor-blood14.png' },
    { name: '김지현', drNameGlb: '김지현', belong: '혈액암병원 외래간호사', belongGlb: '혈액암병원 외래간호사', detailField: '', imageSrc: 'doctor-blood23.png' },
    { name: '이윤희', drNameGlb: '이윤희', belong: '혈액암병원 외래간호사', belongGlb: '혈액암병원 외래간호사', detailField: '', imageSrc: 'doctor-blood13.png' },
    { name: '조다인', drNameGlb: '조다인', belong: '혈액암병원 외래간호사', belongGlb: '혈액암병원 외래간호사', detailField: '', imageSrc: 'doctor-blood11.png' },
    { name: '김수현', drNameGlb: '김수현', belong: '혈액암병원 외래간호사', belongGlb: '혈액암병원 외래간호사', detailField: '', imageSrc: 'doctor_bg.png' },
    { name: '김정현', drNameGlb: '김정현', belong: '진단검사의학과 간호사', belongGlb: '진단검사의학과 간호사', detailField: '', imageSrc: 'nurse_blood07.png' },
    { name: '오수연', drNameGlb: '오수현', belong: '진단검사의학과 간호사', belongGlb: '진단검사의학과 간호사', detailField: '', imageSrc: 'nurse_blood08.png' },
    { name: '오하늘', drNameGlb: '오하늘', belong: '진단검사의학과 간호사', belongGlb: '진단검사의학과 간호사', detailField: '', imageSrc: 'doctor-blood16.png' }
];
const supporter = [
    { name: '김현희', drNameGlb: '김현희', belong: '사회사업팀 파트장, 의료사회복지사', belongGlb: '사회사업팀 파트장, 의료사회복지사', detailField: '', imageSrc: 'doctor-blood17.png' },
    { name: '주예진', drNameGlb: '주예진', belong: '사회사업팀, 의료사회복지사', belongGlb: '사회사업팀, 의료사회복지사', detailField: '', imageSrc: 'doctor-blood18.png' },
    // { name: '김은지', drNameGlb: '김은지', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: '' },
    { name: '사지선', drNameGlb: '사지선', belong: '영양사', belongGlb: '영양사', detailField: '', imageSrc: 'doctor-blood20.png' },
    { name: '이민경', drNameGlb: '이민경', belong: '영양사', belongGlb: '영양사', detailField: '', imageSrc: 'doctor-blood24.png'},
    { name: '최아림', drNameGlb: '최아림', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: '' },
    { name: '이소윤', drNameGlb: '이소윤', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: '' },   
    { name: '유영임', drNameGlb: '유영임', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: '' },
    { name: '이현정', drNameGlb: '이현정', belong: '연구간호사', belongGlb: '연구간호사', detailField: '', imageSrc: '' },
    { name: '안지영', drNameGlb: '안지영', belong: '연구원', belongGlb: '연구원', detailField: '', imageSrc: '' }
    /*{ name: '이성경', drNameGlb: '이성경', belong: '연구원', belongGlb: '연구원', detailField: '', imageSrc: '' }*/
];

// 함수
const getNurse = (name, consonant) => {
    const result = nurse.filter((item) => {return item.name.indexOf(name) > -1})
    if(!consonant){
        return result
    }
    consonant = consonant.split(',')
    return result.filter((item) => {
        for (let i of consonant) {
            if (getChosung(item.name) == i) {
                return item
            }
        }
    })
}
const getSupporter = (name, consonant) => {
    const result = supporter.filter((item) => {return item.name.indexOf(name) > -1})
    if(!consonant){
        return result
    }
    consonant = consonant.split(',')
    return result.filter((item) => {
        for (let i of consonant) {
            if (getChosung(item.name) == i) {
                return item
            }
        }
    })
}
const getChosung = (str) => {
    const chosungList = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];
    const code = str.charCodeAt(0) - 44032;// '가'의 유니코드값
    const chosungIndex = Math.floor(code / 588);
    return chosungList[chosungIndex];
}
const getChosungList = (arr) => {
    return arr.map(item => getChosung(item.name))
}
const getConsonant = (arr) => {
    const data = getChosungList(arr)
    const consonantList = [
        { cho: 'ㄱ~ㄷ', disable: 'disable', choList: ['ㄱ', 'ㄴ', 'ㄷ'], searchText: 'ㄱ,ㄴ,ㄷ' },
        { cho: 'ㄹ~ㅂ', disable: 'disable', choList: ['ㄹ', 'ㅁ', 'ㅂ'], searchText: 'ㄹ,ㅁ,ㅂ' },
        { cho: 'ㅅ~ㅊ', disable: 'disable', choList: ['ㅅ', 'ㅇ', 'ㅈ', 'ㅊ'], searchText: 'ㅅ,ㅇ,ㅈ,ㅊ' },
        { cho: 'ㅋ~ㅎ', disable: 'disable', choList: ['ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'], searchText: 'ㅋ,ㅌ,ㅍ,ㅎ' },
    ]
    for (let i of consonantList) {
        for (let j of data) {
            if (i.choList.includes(j)) {
                i.disable = ''
            }
        }
    }
    return consonantList
}

// 객체 반환
export default {
    nurse, supporter
}
// 함수 반환환
export {
    getNurse,
    getSupporter,
    getChosungList,
    getConsonant
}